// TODO: Keep this file for Vision support, but remove it for responsive.
// TODO: Review whether we can use a minimal data set: https://southwest.atlassian.net/browse/SPASHOP-815
import { swaDate } from "@swa-ui/date";

import { getPersistedCarBookingData, getPersistedCarProductData } from "../carPersistence";

export const generateCarInformationForCart = () => {
  const carBookingData = getPersistedCarBookingData()?.msgRaw || {};
  const persistedCar = getPersistedCarProductData() || {};

  const {
    insuranceData = {},
    insuranceSelected = false,
    supplier = {},
    vehRentalCore = {},
    vehicle,
  } = persistedCar;

  const PickUpLocation = vehRentalCore?.PickUpLocation;
  const ReturnLocation = vehRentalCore?.ReturnLocation;

  const insuranceCost = insuranceData?.planForQuoteRS?.PlanCost;
  const insuranceCostAmount = insuranceSelected ? parseFloat(insuranceCost?.["@Amount"]) : 0;
  const insuranceStateCode =
    carBookingData?.VehResRQCore?.Customer?.Primary?.Address?.StateProv?.["@StateCode"] ?? "";
  const pickupDate = vehRentalCore?.["@PickUpDateTime"] ?? "";
  const returnDate = vehRentalCore?.["@ReturnDateTime"];

  return {
    id: "car",
    selectedCar: {
      hasAnyPromotion: false,
      insuranceSelected,
      insuranceStateCode,
      insuranceAmount: insuranceCostAmount,
      mileageCharge: {},
      name: vehicle?.makeModel ?? "",
      rentalExtras: [],
      discounts: [],
      price: {
        totalPrice: insuranceCostAmount,
        totalPriceWithTaxes: insuranceCostAmount,
        taxes: [],
        rateBreakdown: {
          largestUnitCharge: "",
          largestUnitName: "DAY",
          rateLineItems: [],
        },
      },
    },
    selectedCarType: vehicle?.vehicleCategoryType ?? "",
    selectedVendorCode: supplier?.basicInfo?.companyShortName ?? "",
    query: {
      pickUpDate: swaDate(pickupDate).format("YYYY-MM-DD"),
      pickUpLocation: PickUpLocation?.PickUpLocation?.["@IATA"] ?? "",
      pickUpTime: swaDate(pickupDate).format("HH:mm"),
      returnDate: swaDate(returnDate).format("YYYY-MM-DD"),
      returnLocation: ReturnLocation?.ReturnLocation?.["@IATA"] ?? "",
      returnTime: swaDate(returnDate).format("HH:mm"),
    },
  };
};
